import { prefixerC } from '.'

export const ROUTE_PERMISO_CATEGORIA_ENTIDAD = prefixerC('permiso-categoria-entidad')
